import { gql } from '@apollo/client';
import { Gender, IResidentBaseData, IUpdateHouseDivision } from '@dokucoach/common-types';
import { queryResidentMenuData, queryResidentNameAndId } from './query/residents';

export type ResidentGroupPropType = {
  id: string;
  name: string;
  residents: ResidentPropType[];
  isDefault?: boolean;
  hideEdit?: boolean;
  selectedHouseDivision?: IUpdateHouseDivision;
};

export type ResidentPropType = {
  id: string;
  deletedAt: Date;
  isActive: boolean;
  isAbsent: boolean;
  isApplicant: boolean;
  hasFixation: boolean;
  hasEarlyMedication: boolean;
  hasLateMedication: boolean;
  hasNightMedication: boolean;
  profilePictureUrl?: string | null;
  name: {
    firstFull: string;
    gender: Gender;
    last: string;
    title?: string;
  };
  bed?: { id?: string; label?: string };
  identifier?: string;
  residentBaseData: Partial<IResidentBaseData>;
};

export const GET_RESIDENT_GROUPS_AND_RESIDENTS = gql`
  query getResidentGroupsAndResidents {
    residentGroups {
      id
      name
      isDefault
      residents {
        ${queryResidentMenuData}
      }
      selectedHouseDivision {
        id
      }
    }
    getResidents(isDeleted: false) {
      ${queryResidentMenuData}
    }
  }
`;

export const GET_RESIDENT_GROUPS_AND_RESIDENTS_NAME_AND_ID = gql`
  query getResidentGroupsAndResidents {
    residentGroups {
      id
      name
      isDefault
      residents {
        ${queryResidentNameAndId}
      }
      selectedHouseDivision {
        id
      }
    }
    getResidents(isDeleted: false, isActive: null, isAbsent: null) {
      ${queryResidentNameAndId}
    }
  }
`;
